import React from "react";


/*<div className="nk-footer nk-auth-footer-full">
    <div className="container wide-lg">
        <Row className="g-3">
            <Col lg={6} className="order-lg-last">
                <ul className="nav nav-sm justify-content-center justify-content-lg-end">
                    <li className="nav-item">
                        <Link className="nav-link" target="_blank" to={`${process.env.PUBLIC_URL}/auths/terms`}>
                            Terms &amp; Condition
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" target="_blank" to={`${process.env.PUBLIC_URL}/auths/terms`}>
                            Privacy Policy
                        </Link>
                    </li>


                </ul>
            </Col>
            <Col lg="6">
                <div className="nk-block-content text-center text-lg-left">
                    <p className="text-soft"> &copy; 2022 n4nairmatrimony</p>
                </div>
            </Col>
        </Row>
    </div>
</div>*/
const AuthFooter = () => {
    return (
        <>
            {
                localStorage.getItem('phone') === "yes" ? null : null
                
        }
            
 </> );
};
export default AuthFooter;
